import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { empty, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { IEndereco } from '../endereco.interface';


@Injectable({
  providedIn: 'root'
})
export class CepService extends DefaultService<IEndereco> {

  static URL = '/api/endereco/cep/v1/cep'

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(httpClient, errorHandlerService, CepService.URL);
  }

  buscarEnderecoPorCEP(cep: string): Observable<IEndereco> {
    if ( !cep ) {
      return empty();
    }

    return this.httpClient.get<IEndereco>(`${CepService.URL}/buscarEnderecoPorCEP/${cep}`)
              .pipe(
                catchError( err => {
                  if ( err.status === 404 ) {
                    return throwError(err) 
                  }
                  else {
                    return throwError(this.errorHandlerService.handle(err)) 
                  }
                })
              );
  }
}
